import { useModal, create, show } from "@ebay/nice-modal-react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import useUserRoleDelete from "shared/Role/useDeleteUserRole";

type UnassignConfirmationProps = {
  id: string;
  name: string;
  isLastRole: boolean;
};

const UnassignConfirmation = create(function UnassignConfirmation({
  id,
  name,
  isLastRole,
}: UnassignConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deleteUserRoleBinding, { loading, data }] = useUserRoleDelete({
    refetchQueries: ["UserRoleBindingsWithRoles", "GetUserWithRoles"],
    awaitRefetchQueries: true,
  });

  const onDelete = () => {
    deleteUserRoleBinding({ id })
      .then((result) => {
        if (result?.data?.userRoleBindingDelete?.id) {
          reportSuccess({ message: `${name} role successfully unassigned` });
          modal.resolve();
          modal.hide();
        }
      })
      .catch(onError);
  };

  const handleOnConfirm = () => {
    onDelete();
  };

  return (
    <DeleteConfirmationModal
      isLoading={loading}
      isDismissable={!loading && !data?.userRoleBindingDelete?.id}
      title="Unassign role"
      confirmationButtonLabel="Unassign"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        {isLastRole ? (
          <>
            Unassigning <strong>{name}</strong> will revoke the user's access to Spacelift. They
            will no longer be able to sign in.
            <br />
            <br />
            Are you sure you want to unassign this role?
          </>
        ) : (
          <>
            Are you sure you want to unassign the role <strong>{name}</strong>? You cannot undo this
            action.
          </>
        )}
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showUnassignConfirmation = (props: UnassignConfirmationProps) =>
  show(UnassignConfirmation, props);
